/**
 * Reusable component for displaying sources as clickable Google search links
 */

import { ExternalLink, Sparkles } from 'lucide-react';
import { useDarkMode } from '@/lib/hooks/use-dark-mode';

interface SourceLinksProps {
  sources: Source[];
  className?: string;
}

export function SourceLinks({ sources, className = '' }: SourceLinksProps) {
  const isDarkMode = useDarkMode();

  if (!sources || sources.length === 0) {
    return null;
  }

  return (
    <div className={`text-sm text-muted-foreground italic flex flex-wrap items-baseline gap-x-3 gap-y-1.5 mt-2 ${className}`}>
      <div className="flex flex-wrap items-baseline gap-1.5">
        <span className="font-bold not-italic uppercase text-xs opacity-60">Sources:</span>{' '}
        {sources.map((source, index) => (
          <span key={index} className="flex items-baseline">
            {index > 0 && <span className="mx-1.5 opacity-40">|</span>}
            <a
              href={`https://www.google.com/search?q=${encodeURIComponent(source.searchTerms)}`}
              target="_blank"
              rel="noopener noreferrer"
              className={`inline-flex items-center gap-1 hover:underline decoration-blue-500/30 underline-offset-4 ${isDarkMode ? 'text-blue-400/90 hover:text-blue-300' : 'text-blue-600/90 hover:text-blue-800'}`}
              title={`Search for: ${source.searchTerms}`}
            >
              {source.citation}
              <ExternalLink className="h-3 w-3 opacity-60" />
            </a>
          </span>
        ))}
      </div>
    </div>
  );
}


